<template>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import ScaleBox from '../ol/control/ScaleBox';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        data()
        {
            return {
                idPanel: 'scalebox',
                className: 'ol-scale-box',
            }
        },
        methods:
        {
            addButtonMap: function(_map){
                let panel = _map.getPanel(this.posBtnMap, {'subposition': this.subPosBtnMap});
                if(panel) {
                    let ctrl = new ScaleBox({
                        tipLabel: this.title,
                        className: _map.getControlClassName(this.orderClassName),
                        target: panel.getElement(this.subPosBtnMap),
                        label: 'Scale:',
                        readOnly: false,
                        useRawInput: false,
                    });
                    _map.addControlOL(ctrl);
                    return ctrl;
                }
                return false;
            },
        }

    }
</script>